module.exports = {"Administración de unidades de medida":"Administración de unidades de medida","Listado de unidades de medida":"Listado de unidades de medida","Nombre":"Nombre","Ver unidad de medida":"Ver unidad de medida","Editar unidad de medida":"Editar unidad de medida","Nueva unidad de medida":"Nueva unidad de medida","Abreviatura":"Abreviatura"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/unidades-medidas/es.json
// module id = 1075
// module chunks = 0